import { LevelsOfAssurance } from "./models/levelsOfAssurance";

// Keycloak configs
export const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
export const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM;
export const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
// whether or not to refresh the token
export const refreshKeycloakToken =
  process.env.REACT_APP_KEYCLOAK_REFRESH_TOKEN === "true";
// Base application path
export const baseAppName = process.env.REACT_APP_BASE_APP_NAME;
// Auth service client params
export const baseAuthorizationServerUrl =
  process.env.REACT_APP_AUTH_SERVICE_URL;
export const tokenExchangeEndpoint =
  process.env.REACT_APP_TOKEN_EXCHANGE_ENDPOINT;
export const authAudience = process.env.REACT_APP_AUDIENCE;
export const grantType = process.env.REACT_APP_GRANT_TYPE;
export const subjectTokenType = process.env.REACT_APP_SUBJECT_TOKEN_TYPE;

// Sidebar links
export const sidebar_resources = process.env.REACT_APP_SIDEBAR_RESOURCES;
export const sidebar_help = process.env.REACT_APP_SIDEBAR_HELP;
export const sidebar_applications = process.env.REACT_APP_SIDEBAR_APPLICATIONS;
export const sidebar_identities = process.env.REACT_APP_SIDEBAR_IDENTITIES;
export const sidebar_groups = process.env.REACT_APP_SIDEBAR_GROUPS;

// Default role LoA
export const default_loa = LevelsOfAssurance.CERN;
export const default_role_name = process.env.REACT_APP_DEFAULT_ROLE_NAME;

export const run_env = process.env.REACT_APP_ENVIRONMENT;
export const all_applications_reader =
  process.env.REACT_APP_ALL_APPLICATIONS_READER_ROLE;

console.log("Setting environment as:");
console.log(process.env);
